'use client'

import { useState } from 'react'
import Image from 'next/image'
import { cn } from '@desoutter/uikit'
import { ClippedImage } from '@desoutter/uikit'

type ArticleCarouselProps = {
	images: { id: number; src: string }[]
}
export default function ImageViewer({ images }: ArticleCarouselProps) {
	const [currentImageIndex, setCurrentImage] = useState(0)

	return images[currentImageIndex] ? (
		<>
			<div className="relative mt-8">
				<div className="relative">
					<ClippedImage
						key={images[currentImageIndex].id}
						src={new URL(
							images[currentImageIndex].src +
								'/jcr:content/renditions/cq5dam.web.800.800.jpeg',
						).toString()}
						style={{ objectFit: 'cover', height: '460px', width: '460px' }}
						width={800}
						height={800}
						className="xl:w-[460px] xl:h-[460px] rounded-2xl"
						alt={`image-${images[currentImageIndex].id.toString()}`}
					/>
				</div>
			</div>
			{images.length > 1 && (
				<div className="flex mt-4 mb-8 gap-1 md:gap-4">
					{images.map((image, i) => (
						<div
							className="relative h-20 min-w-20 cursor-pointer"
							onClick={() => setCurrentImage(images.indexOf(image))}
							key={image.id}
						>
							<Image
								loader={() => {
									const url = new URL(
										images[i].src +
											'/jcr:content/renditions/cq5dam.web.400.400.jpeg',
									)
									return url.toString()
								}}
								style={{ objectFit: 'cover', height: '80px', width: '80px' }}
								src="/images/image-placeholder.svg"
								className={cn(
									'relative rounded-2xl',
									images[currentImageIndex].id === image.id &&
										'border border-red-300',
								)}
								width="80"
								height="80"
								alt=""
							/>
						</div>
					))}
				</div>
			)}
		</>
	) : (
		<Image
			src={'/images/image-placeholder.svg'}
			width={800}
			height={800}
			className="max-lg:p-16 pt-0 rounded-2xl"
			alt=""
		/>
	)
}
